// in sass for increase speed of loading webpack
import './model-icon.sass';
export function getDeviceModelProps(device_type) {
    const standard_width = 72;
    const standard_height = 80;
    const base_class_name = 'device-model-icon ';
    switch (device_type) {
        case 'C2000+':
        case 'C2000_PRO':
            return {
                className: base_class_name + 'c2000plus',
                label_top: 50,
                iconSize: [standard_width, standard_height],
            };
        case 'T100':
        case 'T102':
        case 'SX170':
        case 'Mega SX-250':
        case 'SX250':
        case 'SX300':
        case 'GTW-100':
            return {
                className: base_class_name + 'h1',
                label_top: 90,
                iconSize: [50, standard_height],
            };
        case 'H1V_PLUS':
        case 'H1V':
        case 'H1V02_PRO_EBUS':
        case 'H1V02_PRO':
        case 'H1_PRO':
            return {
                className: base_class_name + 'h1v',
                label_top: 100,
                iconSize: [50, standard_height],
            };
        case 'H1000':
            return {
                className: base_class_name + 'h1000',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H1000+':
            return {
                className: base_class_name + 'h1000plus',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H2000':
            return {
                className: base_class_name + 'h2000',
                label_top: 50,
                iconSize: [standard_width, standard_height],
            };
        case 'H2000+':
            return {
                className: base_class_name + 'h2000plus',
                label_top: 50,
                iconSize: [standard_width, standard_height],
            };
        case 'CLIMATIC+':
        case 'CLIMATIC':
            return {
                className: base_class_name + 'climatic',
                label_top: 110,
                iconSize: [65, standard_height],
            };
        case 'SMART_1_0':
        case 'SMART+':
        case 'SMART':
        case 'SMART20_PRO':
        case 'SMART_ZOTA':
        case 'BT_PLUS':
            return {
                className: base_class_name + 'smart',
                label_top: 100,
                iconSize: [standard_width, 69],
            };
        case 'CONNECT_ESP':
            return {
                className: base_class_name + 'connect_esp',
                label_top: 100,
                iconSize: [standard_width, 69],
            };
        case 'SX350':
            return {
                className: base_class_name + 'sx350',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H700_PRO':
            return {
                className: base_class_name + 'h700plus-pro',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H1000_PRO':
            return {
                className: base_class_name + 'h1000pro',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H1500_PRO':
            return {
                className: base_class_name + 'h1500pro',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        case 'H2000_PRO':
            return {
                className: base_class_name + 'h2000pro',
                label_top: 80,
                iconSize: [standard_width, standard_height],
            };
        default:
            return {
                className: base_class_name + 'default',
                label_top: 100,
                iconSize: [standard_width, standard_height],
            };
    }
}
